import { Box, Typography } from '@mui/material';
import { Leaf } from 'lucide-react';

function CertificateHeader() {
  return (
    <Box
      sx={{
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        gap: { xs: 1.5, sm: 2 },
        textAlign: 'center',
        mb: { xs: 4, sm: 6 },
      }}
    >
      <Box
        component="img"
        src="/huelmu_v.svg"
        alt="Huelmu"
        sx={{
          height: { xs: 56, sm: 64 },
          width: 'auto',
        }}
      />
      <Box sx={{ display: 'flex', alignItems: 'center', gap: 1.5, color: 'primary.main' }}>
        <Box sx={{ height: '1px', width: { xs: 24, sm: 40 }, backgroundColor: 'currentColor', opacity: 0.5 }} />
        <Leaf size={14} strokeWidth={1.75} />
        <Box sx={{ height: '1px', width: { xs: 24, sm: 40 }, backgroundColor: 'currentColor', opacity: 0.5 }} />
      </Box>
      <Typography
        variant="overline"
        sx={{
          fontFamily: 'var(--font-heading)',
          fontSize: { xs: '0.85rem', sm: '1rem' },
          letterSpacing: { xs: '0.2em', sm: '0.28em' },
          fontWeight: 500,
          color: 'text.primary',
          lineHeight: 1.2,
        }}
      >
        Certificado de Impacto
      </Typography>
    </Box>
  );
}

export default CertificateHeader;
